import React from "react";
import { Breadcrumb, Form, Input, DatePicker, Select, Button, Table, Space, Modal, Tooltip, InputNumber, Spin } from "antd";
import "./goods_receive_return.css";
import useGoodsReceiveReturnLogic from "../../components/hoc_goods_receive_return";
import ModalDataGoodsReceive from "./modal_data_goods_receive";
import EditDataTableGoodsReceive from "./edit_data_table_good_receive_return";
import AddLineGoodReceiveReturn from "./add_line_good_receive_return";
import { CheckCircleOutlined, LoadingOutlined, StopOutlined, WarningOutlined } from "@ant-design/icons";
import { IoPrintSharp } from "react-icons/io5";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { RiFileCloseFill } from "react-icons/ri";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import { FaPlusCircle } from "react-icons/fa";

const GoodsReceiveReturn: React.FC = () => {
    const {
        transformStyle,
        onDateChange,
        onChange,
        columns,
        rowSelection,
        form,
        onItemGroupChange,
        isModalOpen,
        showModal,
        handleCancel,
        tableData,
        handleRowDoubleClick,
        isEditModalOpen,
        handleEditCancel,
        editingRecord,
        handleTableDoubleClick,
        handleUpdateRecord,
        isAddLineModalOpen,
        showAddLineModal,
        handleAddLineCancel,
        handleAddLineOk,
        handleDeleteSelectedRows,
        autosaveStatus,
        totalReturn,
        totalReturnAmount,
        handleSubmit,
        isGoodsReceiveDisabled,
        handlePrint,
        isSubmitDisabled,
        isVoidDisabled,
        isSubmitModalOpen,
        setIsSubmitModalOpen,
        submitRemark,
        setSubmitRemark,
        handleConfirmSubmit,
        handleVoid,
        isProcessing
    } = useGoodsReceiveReturnLogic();
    const Printbtn = IoPrintSharp as React.ComponentType<any>;
    const Voidbtn = IoIosCloseCircleOutline as React.ComponentType<any>;
    const Closebtn = RiFileCloseFill as React.ComponentType<any>;
    const Submitbtn = HiOutlineDocumentCheck as React.ComponentType<any>;

    return (
        <Spin spinning={isProcessing} tip="Sedang memproses data..." size="large">
            <div id="iau9-grr" style={transformStyle}>
                <div className="gjs-grid-row" id="-grr">
                    <div className="gjs-grid-column" id="isb14-grr">
                        <Breadcrumb
                            items={[
                                {
                                    href: "#/dashboard/data_goods_receive_return",
                                    title: (
                                        <>
                                            <span>Data Goods Receive Return</span>
                                        </>
                                    ),
                                },
                                { title: "Goods Receive Return - SP" },
                            ]}
                        />
                    </div>
                </div>

                <div className="gjs-grid-row" id="ghghgjf">
                    <div className="gjs-grid-column" id="jjjghf">
                        <Button className="gr-button" disabled={autosaveStatus === 'processing'}>
                            <FaPlusCircle style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            New
                        </Button>
                        <Button className="gr-button" onClick={handleSubmit} disabled={isSubmitDisabled || autosaveStatus === 'processing'}>
                            <Submitbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Submit
                        </Button>
                        <Button className="gr-button" onClick={handleVoid} disabled={isVoidDisabled || autosaveStatus === 'processing'}>
                            <Voidbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Void
                        </Button>
                        <Button className="gr-button" onClick={handlePrint} disabled={autosaveStatus === 'processing'}>
                            <Printbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Print
                        </Button>
                        <Space style={{ marginLeft: '10px' }}>
                            {autosaveStatus === 'processing' && (
                                <Tooltip title="Autosave sedang berjalan...">
                                    <LoadingOutlined style={{ color: '#1890ff' }} />
                                </Tooltip>
                            )}
                            {autosaveStatus === 'error' && (
                                <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                    <WarningOutlined style={{ color: '#ff4d4f' }} />
                                </Tooltip>
                            )}
                            {autosaveStatus === 'stopped' && (
                                <Tooltip title="Autosave Stopped">
                                    <StopOutlined style={{ color: '#bfbfbf' }} />
                                </Tooltip>
                            )}
                            {autosaveStatus === 'idle' && (
                                <Tooltip title="Autosave berhasil.">
                                    <CheckCircleOutlined style={{ color: '#52c41a' }} />
                                </Tooltip>
                            )}
                        </Space>
                    </div>
                </div>
                <div className="gjs-grid-row" id="iachd-grr">
                    <div className="gjs-grid-column" id="ivi1h-grr">
                        <Form
                            scrollToFirstError={true}
                            form={form}
                            layout="horizontal"
                            style={{ maxWidth: 500 }}
                            labelCol={{ style: { width: "190px", textAlign: "left" } }}
                            wrapperCol={{ style: { width: "290px" } }}
                            className="custom-info-purchase-request">
                            <Form.Item label="Status" name="status" style={{ marginBottom: "5px" }}>
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item label="Goods Receive Return No" name="goods_receive_return_no" style={{ marginBottom: "5px" }}>
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Date"
                                name="date"
                                style={{ marginBottom: "5px" }}
                                rules={[{ required: true, message: 'Wajib diisi' }]}
                            >
                                <DatePicker
                                    onChange={onDateChange}
                                    format="DD/MM/YYYY"
                                    placeholder="Select date"
                                    style={{ width: "40%", fontSize: "14px" }}
                                    popupStyle={{ fontSize: "12px" }}
                                />
                            </Form.Item>
                            <Form.Item label="Item Group" name="item_group" style={{ marginBottom: "5px" }} rules={[{ required: true, message: 'Wajib diisi' }]}>
                                <Select
                                    showSearch
                                    placeholder="Select Group"
                                    optionFilterProp="label"
                                    onChange={onItemGroupChange}
                                    options={[
                                        { value: "", label: "-- Empty --" },
                                        { value: "1", label: "Inventory" },
                                        { value: "2", label: "Outside Job" },
                                    ]}
                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                />
                            </Form.Item>
                            <Form.Item label="Reference Type" name="reference_type" style={{ marginBottom: "5px" }} rules={[{ required: true, message: 'Wajib diisi' }]}>
                                <Select
                                    showSearch
                                    placeholder="Select Reference Type"
                                    optionFilterProp="label"
                                    onChange={onChange}
                                    options={[
                                        { value: "1", label: "Part Claim" },
                                        { value: "2", label: "Purchase Order" },
                                        { value: "3", label: "Warranty Claim" },
                                    ]}
                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                />
                            </Form.Item>
                            <Form.Item label="Goods Receive No." style={{ marginBottom: "5px" }}>
                                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    <Form.Item name="goods_receive_no" noStyle style={{ width: "85%" }}>
                                        <Input placeholder="" style={{ width: "90%" }} disabled={isGoodsReceiveDisabled} />
                                    </Form.Item>
                                    <Button
                                        type="primary"
                                        id="modal_data_goods_receive"
                                        onClick={showModal}
                                        disabled={isGoodsReceiveDisabled || autosaveStatus === 'processing'}
                                        icon={
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="currentColor"
                                                style={{ width: "22px", height: "22px" }}>
                                                <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                                <path
                                                    fillRule="evenodd"
                                                    d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                                    clipRule="evenodd"
                                                />
                                                <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                            </svg>
                                        }
                                    />
                                </div>
                            </Form.Item>
                            <Form.Item label="Supplier Code" name="supplier_code" style={{ marginBottom: "5px" }}>
                                <Input placeholder="" style={{ width: "50%" }} readOnly />
                            </Form.Item>
                            <Form.Item label="Supplier Name" name="supplier_name" style={{ marginBottom: "5px" }}>
                                <Input placeholder="" style={{}} readOnly />
                            </Form.Item>
                            <Form.Item label="Supplier Invoice No." name="supplier_invoice_no" style={{ marginBottom: "5px" }}>
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item label="Tax Invoice No" name="tax_invoice_no" style={{ marginBottom: "5px" }}>
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item label="Warehouse" name="warehouse" style={{ marginBottom: "5px" }}>
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item label="Remark" name="remark" style={{ marginBottom: "5px" }}>
                                <Input.TextArea rows={4} placeholder="Enter your remarks here..." />
                            </Form.Item>
                            <Form.Item label="Total Amount" name="total_amount" style={{ marginBottom: "5px" }}>
                                <InputNumber
                                    readOnly
                                    style={{ width: "100%", backgroundColor: '#f0f0f0' }}
                                    formatter={(value) => new Intl.NumberFormat('id-ID').format(value as number)}
                                    parser={(value) => value!.replace(/\./g, '')}
                                />
                            </Form.Item>
                        </Form>
                    </div>
                </div>

                {/* Grid Row 3 */}
                <div className="gjs-grid-row" id="iieaj-grr">
                    <div className="gjs-grid-column" id="i8c9p-grr">
                        <Table
                            rowSelection={rowSelection}
                            columns={columns}
                            dataSource={tableData}
                            scroll={{ x: 900 }}
                            className="table-gr"
                            onRow={(record) => {
                                return {
                                    onDoubleClick: () => handleTableDoubleClick(record),
                                };
                            }}
                            summary={() => {
                                return (
                                    <Table.Summary fixed>
                                        <Table.Summary.Row>
                                            <Table.Summary.Cell index={0} />
                                            <Table.Summary.Cell index={1} colSpan={9} align="left">
                                                <strong>Total</strong>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={10} align="left">
                                                <strong>{new Intl.NumberFormat('id-ID').format(totalReturn)}</strong>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={11} align="left">
                                                <strong>{new Intl.NumberFormat('id-ID').format(totalReturnAmount)}</strong>
                                            </Table.Summary.Cell>
                                        </Table.Summary.Row>
                                    </Table.Summary>
                                );
                            }}
                        />
                        <div style={{ marginTop: "20px", textAlign: "left" }}>
                            <Space>
                                <Button
                                    type="primary"
                                    onClick={showAddLineModal}
                                    disabled={autosaveStatus === 'processing'}
                                    style={{
                                        height: "40px",
                                        width: "105px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            style={{ width: "22px", height: "22px" }}>
                                            <path
                                                fillRule="evenodd"
                                                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    }>
                                    Add Line
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={handleDeleteSelectedRows}
                                    disabled={autosaveStatus === 'processing'}
                                    style={{
                                        height: "40px",
                                        width: "90px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            style={{ width: "22px", height: "22px" }}>
                                            <path
                                                fillRule="evenodd"
                                                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    }>
                                    Delete
                                </Button>
                            </Space>
                        </div>
                    </div>
                </div>
                <Modal
                    title="Data Goods Receive"
                    open={isModalOpen}
                    onCancel={handleCancel}
                    footer={null}
                    width={1000}>
                    <ModalDataGoodsReceive onRowDoubleClick={handleRowDoubleClick} />
                </Modal>
                <Modal
                    title="Edit Data Goods Receive Return"
                    className="modal_edit_gr_return"
                    open={isEditModalOpen}
                    onCancel={handleEditCancel}
                    footer={null}
                    width={400}
                >
                     <EditDataTableGoodsReceive record={editingRecord} onCancel={handleEditCancel} onOk={handleUpdateRecord} warehouse={form.getFieldValue('warehouse')} />
                </Modal>
                <Modal
                    title="Add Line Goods Receive Return"
                    open={isAddLineModalOpen}
                    onCancel={handleAddLineCancel}
                    footer={null}
                    width={1300}
                >
                    <AddLineGoodReceiveReturn
                        goodsReceiveNo={form.getFieldValue('goods_receive_no')}
                        onCancel={handleAddLineCancel}
                        onSelectLines={handleAddLineOk}
                        existingData={tableData}
                    />
                </Modal>
                <Modal
                    title="Input Remark Approval"
                    open={isSubmitModalOpen}
                    onOk={handleConfirmSubmit}
                    onCancel={() => {
                        setIsSubmitModalOpen(false);
                        setSubmitRemark("");
                    }}
                    okText="Submit"
                    cancelText="Cancel"
                    destroyOnClose
                >
                    <div style={{ marginTop: "15px" }}>
                        <p style={{ marginBottom: "8px" }}>Silakan isi remark untuk proses approval:</p>
                        <Input.TextArea
                            rows={3}
                            value={submitRemark}
                            onChange={(e) => setSubmitRemark(e.target.value)}
                            placeholder="Tulis remark di sini..."
                        />
                    </div>
                </Modal>
            </div>
        </Spin>
    );
};

export default GoodsReceiveReturn;